import React from 'react';

const HCardd = ({ imageSrc, cardBody, className, colClassNameImg = "col-md-4", colClassNameImg1 = "col-md-8", onClick }) => {
    return (
        <div className={`card mb-3 ${className}`} onClick={onClick}>
            <div className="row g-0">
                <div className={colClassNameImg}>
                    <div className="img-blk">
                        <img src={imageSrc} className="img-fluid image" alt="..." />
                    </div>
                </div>
                <div className={colClassNameImg1} >
                    <div className="card-body">
                        {cardBody}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HCardd;
